"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.upgrade.message': 'Actualice su plan de cuenta para acceder a esta función.',
    'limits.upgrade.link': 'Actualizar Ahora',
};
